import { Component, input } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

import { Icon } from '../icon';

@Component({
    selector: 'stby-tooltip',
    imports: [Icon, MatTooltipModule, TranslatePipe],
    templateUrl: './tooltip.html',
    styleUrl: './tooltip.scss',
})
export class Tooltip {
    readonly tooltip = input<string>();
    readonly tooltipPosition = input<TooltipPosition>('right');
}
